import { useLang } from '@/i18n';
import EcoBarPromo from 'eco-design/sections-test/eco-bar-promo';
import style from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct');

    return (
        <div className={style.comp}>
            <EcoBarPromo logo="https://websiteoss.ecoflow.com/upload/image/1744339311890/jg.png" title={t('bar_text')} />
        </div>
    );
}
